const styles = theme => ({
    chip: {
        minWidth: 60,
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            marginRight: theme.spacing(1),
            minWidth: 60,
        }
    }
});

export default styles;